// 宮崎県農業クイズ - 10問1セット×10セット

import { quizData } from './quizData';

export const quizSets = [
  {
    id: 1,
    title: "セット1: 宮崎牛の基礎知識",
    category: "宮崎牛",
    questions: quizData.slice(0, 10)
  },
  {
    id: 2,
    title: "セット2: 宮崎牛の歴史と栄光",
    category: "宮崎牛",
    questions: quizData.slice(10, 20)
  },
  {
    id: 3,
    title: "セット3: みやざき地頭鶏とブランドポーク",
    category: "畜産",
    questions: quizData.slice(20, 30)
  },
  {
    id: 4,
    title: "セット4: 地頭鶏とブランドポーク詳細",
    category: "畜産",
    questions: quizData.slice(30, 40)
  },
  {
    id: 5,
    title: "セット5: 宮崎の果物王国",
    category: "果物",
    questions: quizData.slice(40, 50)
  },
  {
    id: 6,
    title: "セット6: フルーツと野菜の産地",
    category: "農産物",
    questions: quizData.slice(50, 60)
  },
  {
    id: 7,
    title: "セット7: 野菜と水産業",
    category: "農産物・水産",
    questions: quizData.slice(60, 70)
  },
  {
    id: 8,
    title: "セット8: 黒潮の恵みと養殖技術",
    category: "水産業",
    questions: quizData.slice(70, 80)
  },
  {
    id: 9,
    title: "セット9: 林業・焼酎と伝統",
    category: "林業・焼酎",
    questions: quizData.slice(80, 90)
  },
  {
    id: 10,
    title: "セット10: 宮崎農業の歴史と未来",
    category: "歴史・文化",
    questions: quizData.slice(90, 100)
  }
];

// 全クイズデータを1つの配列にまとめたもの（既存のコードとの互換性のため）
export const allQuizData = quizSets.flatMap(set => set.questions);
